import Box from "@material-ui/core/esm/Box";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditButton from 'components/Button/EditButton';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { getPhoneNumberString } from 'utils/phone/parsePhoneNumber';
import ProfileItem from '../ProfileItem';
import useStyles from '../ProfileStyles';
import PhoneDialog from './PhoneDialog';
export default function Phone({
  fieldName
}) {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    profileRow,
    actionButton
  } = useStyles();
  const [isContactPhoneNrDialogOpen, setIsContactPhoneNrDialogOpen] = useState(false);
  const phoneNumber = customer ? customer[fieldName] : undefined;
  if (customer && phoneNumber === undefined) throw new Error(`Field name '${fieldName}' doesn't exist on current customer's object!`);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneDialog, {
    open: isContactPhoneNrDialogOpen,
    onClose: () => setIsContactPhoneNrDialogOpen(false),
    phoneNumber: phoneNumber,
    fieldName: fieldName
  }), /*#__PURE__*/React.createElement("div", {
    className: profileRow
  }, /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.telephone'),
    value: getPhoneNumberString(phoneNumber)
  }), /*#__PURE__*/React.createElement(Box, {
    pb: 0.5
  }, /*#__PURE__*/React.createElement(EditButton, {
    onClick: () => setIsContactPhoneNrDialogOpen(true),
    className: actionButton
  }, t('buttons.edit')))));
}